import { useEffect } from 'react';

import getOSName, { OSName } from '@/helpers/userAgent/getOSName';
import isSafari from '@/helpers/util/isSafari';

const useSafariNavbarOverlapToggle = () => {
  useEffect(() => {
    if (getOSName() === OSName.iOS && isSafari()) {
      setTimeout(() => {
        window.scrollBy({ behavior: 'instant', top: 1 });
      }, 100);
    }
  }, []);
};

export const SafariNavbarOverlapToggle = () => {
  useSafariNavbarOverlapToggle();
};

export default useSafariNavbarOverlapToggle;
